import React from 'react';
import { generateSlug } from '../../../utils/generateSlug';
import { Box } from '@mui/material';
import * as styles from './dropdownMenu.module.scss';

interface IDropdownMenuProps {
    open: boolean;
    setOpen: any;
    selectedCat: { index: number; label: string };
    handleTabClick: any;
    tabs: string[];
    gtmBtnClass?: string;
}

const DropdownMenu = ({
    open,
    setOpen,
    selectedCat,
    handleTabClick,
    tabs,
    gtmBtnClass,
}: IDropdownMenuProps) => {
    return (
        <Box className={styles.m_dropdownmenu}>
            <button
                onClick={() => setOpen(!open)}
                className={styles.m_dropdownmenu__trigger}
            >
                <span>{selectedCat.label}</span>
                {open ? (
                    <i className="icon-chevron-up" />
                ) : (
                    <i className="icon-chevron-down1" />
                )}
            </button>
            {open && (
                <button className={styles.m_dropdownmenu__options}>
                    {tabs.map((tab, index) => (
                        <button
                            key={tab}
                            onClick={() => handleTabClick(tab, index)}
                            className={`${
                                gtmBtnClass
                                    ? `gtm_click_submenu_comfama_home_body_interes_${generateSlug(
                                          tab,
                                      )}`
                                    : ''
                            } ${styles.m_dropdownmenu__option}`}
                        >
                            {tab}
                        </button>
                    ))}
                </button>
            )}
        </Box>
    );
};

export default DropdownMenu;
